import type { SelectHTMLAttributes } from 'react'

type BuxusSelectProps = SelectHTMLAttributes<HTMLSelectElement>

/** Styled native select — matches registration form caret spacing (template-level fix). */
export function BuxusSelect({ className, children, ...rest }: BuxusSelectProps) {
  const classes = ['buxus-select', className].filter(Boolean).join(' ')
  return (
    <select className={classes} {...rest}>
      {children}
    </select>
  )
}
